import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  H5,
  LoadingBigIcon,
  SmallText,
} from "../../components/textStyles/style";
import axios from "axios";
import { usersRolesOptions } from "../../data/SelectOptions";
import { ButtonPrimaryLink } from "../../components/buttonStyles/style";
import { SearchInput } from "../../components/Inputs";
import moment from "moment";

let Height = "calc(100vh - clamp(54px, 8vw, 84px) - 62px)";

const Wrapper = styled.div`
  width: 100vw;
  min-height: ${Height};
  display: flex;
  justify-content: center;
`;
const ContentWrapper = styled.div`
  background-color: white;
  width: 90%;
  padding: 30px;
  border-radius: 20px;
  margin: 30px 0;
`;

const LoadWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 50px;
  align-items: center;
  justify-content: center;
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`;

const Users = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getData = async (keyword) => {
    setLoader(true);
    const TOKEN = localStorage.getItem("TOKEN");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
    };
    const Response = await axios.get(
      `${process.env.REACT_APP_DASHBOARD_USERS}?keyword=${keyword}`,
      config
    );
    console.log(Response.data);

    const users = Response.data;
    setData(users);

    setLoader(false);
  };

  useEffect(() => {
    getData(keyword);
  }, [keyword]);

  return (
    <Wrapper>
      <ContentWrapper>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 15,
          }}
        >
          <div style={{ width: 300 }}>
            <ButtonPrimaryLink width={300} to="/add-user">
              Add new user
            </ButtonPrimaryLink>
          </div>
          <SearchContainer>
            <SearchInput
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />

            <SmallText>{data.length} users found</SmallText>
          </SearchContainer>
        </div>
        <H5>Dashboard Users</H5>
        {loader ? (
          <LoadWrapper>
            <LoadingBigIcon />
          </LoadWrapper>
        ) : (
          <div style={{ margin: 30 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Firstname
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Lastname
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Mail address
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Role
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Last connexion
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "#1B4965" }}
                  >
                    Created At
                  </TableCell>
                </TableHead>
                <TableBody>
                  {data.map((user) => {
                    const r = usersRolesOptions.find(
                      (el) => el.value === user.role
                    );
                    return (
                      <TableRow key={user._id}>
                        <TableCell align="center" scope="row">
                          {user.firstname}
                        </TableCell>
                        <TableCell align="center">{user.lastname}</TableCell>
                        <TableCell align="center">{user.username}</TableCell>

                        <TableCell align="center">
                          {r ? r.label : " - "}
                        </TableCell>
                        <TableCell align="center">
                          {moment(user.last_connexion).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {" "}
                          {moment(user.createdAt).format("DD/MM/YYYY HH:mm")}
                        </TableCell>
                        <TableCell align="center">
                          <ButtonPrimaryLink
                            to={`/user/${user._id}`}
                            width="40px"
                            height="40px"
                          >
                            &#8594;
                          </ButtonPrimaryLink>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </ContentWrapper>
    </Wrapper>
  );
};

export default Users;
